import palette from "../../../assets/look/player-colors.json";
import type { AppState } from "./types";

// Matches characters/colors.rs: rank the complete roster by ID, never by
// score, alive state, team or global ID remainder. Reconnects keep their color.
export function playerColorIndex(
  id: number,
  roster: readonly number[],
): number {
  if (!roster.includes(id)) return 0;
  return roster.filter((other) => other < id).length;
}

export function playerColorStyle(index: number): string {
  const color = palette[index];
  const shadow = color.map((channel) => Math.round(channel * 0.65));
  return `--robe:rgb(${shadow.join(" ")});--trim:rgb(${color.join(" ")})`;
}

export function colorRoster(state: AppState): number[] {
  return (
    state.snapshot?.players.map((player) => player.id) ??
    state.room?.slots.flatMap((slot) =>
      slot.member ? [slot.member.playerId] : [],
    ) ?? [state.playerId]
  );
}
